import { gql } from '@apollo/client';

export interface AgencyCommission {
  agency: {
    commission: number;
  };
}

export const AGENCY_COMMISSION = gql`
  query($userId: String!) {
    agency(userId: $userId) {
      commission
    }
  }
`;
